// #8 Termo de Sigilo e Confidencialidade — template estático + assinaturas dos
// membros do comitê. ZERO conteúdo do caso (não depende de cifrado). Pure.

import type { FormBlock } from './form-pdf.js';
import { manualField } from './form-pdf.js';
import { type FormInput, categoriaLabel, competenciaLabel, subRoleLabel } from './forms-common.js';

export function buildSigilo(input: FormInput): FormBlock[] {
  const blocks: FormBlock[] = [
    { kind: 'title', text: 'Termo de Sigilo e Confidencialidade' },
    {
      kind: 'paragraph',
      text:
        'Os membros do comitê de apuração abaixo assinados comprometem-se a manter ' +
        'absoluto sigilo sobre todas as informações, documentos e fatos de que tomarem ' +
        'conhecimento em razão da investigação interna referenciada, sob pena de ' +
        'responsabilização nos termos da Lei 14.457/2022, da Lei 13.709/2018 (LGPD) e do ' +
        'Código de Conduta da Contato Facilites.',
    },
    { kind: 'section', text: 'Identificação do processo' },
    { kind: 'field', label: 'Processo (protocolo):', value: input.caseId },
    { kind: 'field', label: 'Categoria:', value: categoriaLabel(input.categoria) },
    { kind: 'field', label: 'Comitê de competência:', value: competenciaLabel(input.categoria) },
    manualField('Data:'),
    {
      kind: 'paragraph',
      text:
        'Declaro estar ciente de que a quebra do dever de sigilo constitui infração ' +
        'disciplinar grave e poderá ensejar medidas administrativas, civis e penais ' +
        'cabíveis, preservando-se em especial o anonimato do denunciante de boa-fé.',
    },
    { kind: 'section', text: 'Membros signatários' },
  ];

  if (input.members.length === 0) {
    blocks.push(manualField('Nome / Papel:'));
    blocks.push({ kind: 'signature', nome: '', papel: '' });
  } else {
    for (const m of input.members) {
      blocks.push({ kind: 'signature', nome: m.email, papel: subRoleLabel(m.subRole) });
    }
  }

  return blocks;
}
